<template>
  <div class="register">
    <div class="layout">
      <h1 class="text-center mb-2">
      </h1>
      <el-card shadow="hover">
        <img src="@/assets/images/ilogo.png"  alt />
        <div class="content">
          <img src="@/assets/images/signup-image.jpg" alt />
          <div class="form">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
              <h2 class="text-center mb-2">{{$t('auth.register.title')}}</h2>
              <el-form-item prop="email">
                <el-input
                  v-model="ruleForm.email"
                  :placeholder="$t('auth.register.email.placeholder')"
                ></el-input>
                <span class="icon">
                  <i class="fas fa-envelope"></i>
                </span>
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  v-model="ruleForm.password"
                  type="password"
                  show-password
                  :placeholder="$t('auth.register.password.placeholder')"
                ></el-input>
                <span class="icon">
                  <i class="fas fa-lock"></i>
                </span>
              </el-form-item>
              <el-form-item prop="confirmPassword">
                <el-input
                  v-model="ruleForm.confirmPassword"
                  type="password"
                  show-password
                  :placeholder="$t('auth.resetPassword.passwordConfirm.placeholder')"
                ></el-input>
                <span class="icon">
                  <i class="fas fa-lock"></i>
                </span>
              </el-form-item>
              <el-form-item prop="fullName">
                <el-input
                  v-model="ruleForm.fullName"
                  :placeholder="$t('auth.register.fullName.placeholder')"
                ></el-input>
                <span class="icon">
                  <i class="fas fa-user"></i>
                </span>
              </el-form-item>
              <vue-phone-number-input 
                v-model="ruleForm.phoneNumber"
                :required="true"
                default-country-code="VN"
                :translations="{
                  countrySelectorLabel: 'Quốc gia',
                  countrySelectorError: 'Lỗi',
                  phoneNumberLabel: $t('auth.register.phoneNumber.placeholder'),
                  example: ''
                }"
                valid-color="#0093FF"
                @update="getCountryCode"
              />
              <div v-show="!rules.phoneNumber.pass" style="font-size: 11px;color: #dc3545;margin-top: 6px;">{{ rules.phoneNumber.mess }}</div>
              <p class="mb-1" v-html="$t('auth.register.privacy')"></p>
              <el-form-item>
                <el-button
                  type="primary"
                  :disabled="isCreatingAccount"
                  @click="!isCreatingAccount ? handleCreateAccount(ruleForm) : null"
                  class="w-100"
                >
                  {{$t('auth.register.btn')}}
                  <i class="el-icon-loading" v-if="isCreatingAccount"></i>
                </el-button>
              </el-form-item>
              <div class="text-right">
                <p class="text-center" v-html="$t('auth.register.login')"></p>
              </div>
            </el-form>
            <!-- <div
              class="d-flex align-items-center justify-content-center mt-2"
              v-if="locale === 'vi'"
            >
              <i class="idc-icons icon-flag-en"></i>
              <a @click="setLocale('en')">
                <strong>{{$t('languageEn')}}</strong>
              </a>
            </div>
            <div class="d-flex align-items-center justify-content-center mt-2" v-else>
              <i class="idc-icons icon-flag-vi"></i>
              <a @click="setLocale('vi')">
                <strong>{{$t('languageVi')}}</strong>
              </a>
            </div>-->
            <el-row type="flex" justify="end" class="language">
              <p @click="setLocale('en')" class="text-right mr-1">
                <i class="idc-icons icon-flag-en"></i>
              </p>
              <p @click="setLocale('vi')" class="text-right">
                <i class="idc-icons icon-flag-vi"></i>
              </p>
            </el-row>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
 import authServices from '@/services/auth'
 import VuePhoneNumberInput from 'vue-phone-number-input'
 import 'vue-phone-number-input/dist/vue-phone-number-input.css'

 export default {
   name: 'Register',
   data () {
     const validatePass = (rule, value, callback) => {
       if (value === '') {
         callback(new Error(this.$t('auth.resetPassword.password.required')))
       } else {
         if (this.ruleForm.confirmPassword !== '') {
           this.$refs.ruleForm.validateField('confirmPassword')
         }
         callback()
       }
     }
     const validatePass2 = (rule, value, callback) => {
       if (value === '') {
         callback(new Error(this.$t('auth.resetPassword.passwordConfirm.required')))
       } else if (value !== this.ruleForm.password) {
         callback(new Error(this.$t('auth.resetPassword.passwordConfirm.notmatch')))
       } else {
         callback()
       }
     }
     return {
       locale: localStorage.locale,
       isCreatingAccount: false,
       ruleForm: {
         email: '',
         password: '',
         confirmPassword: '',
         fullName: '',
         phoneNumber: '',
         formattedPhone: ''
       },
       rules: {
         email: [
           { required: true, message: this.$t('auth.register.email.required'), trigger: ['blur', 'change'] }
         ],
         password: [
           { validator: validatePass, trigger: ['blur', 'change'] }
         ],
         confirmPassword: [
           { validator: validatePass2, trigger: ['blur', 'change'] }
         ],
         fullName: [
           { required: true, message: this.$t('auth.register.fullName.required'), trigger: ['blur', 'change'] }
         ],
         phoneNumber: {
           pass: false,
           mess: ''
         }
         // phoneNumber: [
         //   { required: true, message: this.$t('auth.register.phoneNumber.required'), trigger: ['blur', 'change'] },
         //   { pattern: config.PATTERN_PHONENUMBER,
         //     message: this.$t('auth.register.phoneNumber.pattern'),
         //     trigger: ['blur', 'change']
         //   }
         // ]
       }
     }
   },
   components: {
     'vue-phone-number-input': VuePhoneNumberInput
   },
   methods: {
     setLocale (locale) {
       this.$emit('setLocale', locale)
       localStorage.locale = locale
       this.locale = locale
     },
     handleCreateAccount (form) {
       if (this.isCreatingAccount) return
       this.$refs.ruleForm.validate((valid) => {
         if (!this.ruleForm.phoneNumber || this.ruleForm.phoneNumber === '') {
           this.rules.phoneNumber.pass = false
           this.rules.phoneNumber.mess = this.$t('auth.register.phoneNumber.required')
         }
         if (valid && this.rules.phoneNumber.pass) {
           this.isCreatingAccount = true
           form.formatted_phone = this.ruleForm.formattedPhone
           authServices.register(form)
             .then(res => {
               authServices.login({email: form.email, password: form.password})
                 .then(res => {
                   this.isCreatingAccount = false
                   this.$notify({
                     message: this.$t('notify.success.registerAccount'),
                     showClose: false,
                     duration: 3000,
                     customClass: 'success'
                   })
                 })
             })
             .catch(e => {
               console.log(e)
               this.isCreatingAccount = false
               let msg = ''
               if (e.response.data && e.response.data.message) {
                 msg = e.response.data.message
               }
               this.isCreatingVolume = false
               this.$notify({
                 message: msg,
                 showClose: false,
                 duration: 3000,
                 customClass: 'error'
               })
             })
         }
       })
     },
     getCountryCode (res) {
       if (!res.isValid) {
         this.rules.phoneNumber.pass = false
         this.rules.phoneNumber.mess = this.$t('auth.register.phoneNumber.pattern')
       } else {
         this.rules.phoneNumber.pass = true
         this.ruleForm.formattedPhone = res.formattedNumber
       }
     }
   },
   mounted () {
     if (this.$router.history.current.query && this.$router.history.current.query.redirect !== '') {
       let cpu = parseInt(this.$router.history.current.query.cpu) || 1
       let ram = parseInt(this.$router.history.current.query.ram) || 1
       let diskSize = parseInt(this.$router.history.current.query.disk) || 10
       let diskType = 'SSD'
       let qtyIPv4 = 0
       let qtyIPv6 = 0

       let interval_count = parseInt(this.$router.history.current.query.interval_count) || 1

       if (this.$router.history.current.query.billingcycle && this.$router.history.current.query.billingcycle === 'annually') {
         interval_count = 12
       }

       let orderData = {
         type: 'create_server',
         data: {
           os: {
           },
           name: '',
           key_name: '',
           password: true,
           rootdisk: {
             size: diskSize,
             type: diskType,
             uom: 'GB'
           },
           datadisks: [],
           flavor_name: `${cpu}c_${ram}g`,
           cpu: {
             quantity: cpu,
             uom: 'Core'
           },
           ram: {
             quantity: ram,
             uom: 'GB'
           },
           ipv4: {
             quantity: qtyIPv4
           },
           ipv6: {
             quantity: qtyIPv6
           },
           datacenter: 'HN',
           extra_products: []
         },
         interval_count: interval_count,
         products: [
           { id_or_name: `cpu_${cpu}c`, quantity: 1 },
           { id_or_name: `ram_${ram}gb`, quantity: 1 },
           { id_or_name: `volume_${diskType.toLowerCase()}_${diskSize}gb`, quantity: 1 },
           { id_or_name: 'wan_ipv4_1', quantity: qtyIPv4 },
           { id_or_name: 'wan_ipv6_1', quantity: qtyIPv6 }
         ]
       }
       localStorage.setItem('orderData', JSON.stringify(orderData))
       localStorage.setItem('callbackURL', this.$router.history.current.query.redirect)
     }
     if (localStorage.locale) {
       this.locale = localStorage.locale
     } else {
       this.locale = 'vi'
     }
     this.setLocale(this.locale)
   }
 }
</script>

<style lang="scss" scoped>
.register {
  width: 100%;
  height: 100vh;
  padding: 20px;
  background: #f8f8f8;
  display: flex;
  justify-content: center;
  align-items: center;
  .el-card {
    width: 800px;
    border-radius: 20px;
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .form {
        width: 50%;
        .el-input {
          margin-top: 10px;
        }
        .icon {
          position: absolute;
          left: 5px;
          bottom: 0px;
          font-size: 16px;
          color: #676767;
        }
        .language {
          p {
            i {
              cursor: pointer;
            }
          }
        }
      }
      img {
        width: 45%;
      }
    }
  }
}
@media (max-width: 767px) {
  .register {
    padding: 20px;
    .layout {
      width: 100%;
      .el-card {
        width: 100%;
      }
    }
  }
}
@media (max-width: 480px) {
  .register {
    padding: 20px;
    .layout {
      .el-card {
        .form {
          width: 100%;
        }
        img {
          display: none;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.register {
  .el-input__inner {
    border-radius: 0;
    border-left: none;
    border-top: none;
    border-right: none;
    padding-left: 30px;
  }
  .el-form-item__content {
    position: relative;
  }
  ::placeholder {
    color: #676767;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/auth/register.vue